module.exports = __webpack_public_path__ + "static/media/05_360.3f8293ef.jpeg";